import styled from 'styled-components';

const ContentInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  &:last-child {
    margin: 0;
  }
`;
const ContentNumber = styled.p`
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  color: #494c66;
`;
const ContentText = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: #494c66;
`;

const ContentAmount = styled.p`
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  color: #494c66;
`;

export { ContentInfo, ContentNumber, ContentText, ContentAmount };
